<template>
<Teleport to="#modal-portal-target">
<div v-if="$store.getters['common/modalName'] === 'resourcecommentmodal'">
    <div class="modal-header">
        <select class="form-control" 
            v-if="resources.length > 0"
            v-model="selectedResourceId">
            <option v-for="resource in resources" 
                :value="resource.resourceId">
                {{ resource.title }}
            </option>
        </select>
        <h3 class="modal-title" v-else>
            {{ resource.title }} - {{ $_locale('comments', false) }}
        </h3>
    </div>

    <div class="modal-body reservation-modal resourcecomment-modal">
        <div v-show="view === 'list'">
            <div v-if="resourceCommentRows.length === 0">
                <h3 style="text-align: center;">{{ $_locale('no comments for selected day') }}.</h3>
            </div>
            <wn-table-pages :items="resourceCommentRows" v-else>
                <template #head>
                    <th>{{ $_locale('commentator') }}</th>
                    <th style="min-width: 50%;">{{ $_locale('comment') }}</th>
                    <th>{{ $_locale('date created') }}</th>
                    <th>{{ $_locale('validity') }}</th>
                    <th>{{ $_locale('public') }}</th>
                    <th style="min-width: 65px;"></th>
                </template>
                <template v-slot="{ item: row }">
                    <tr :key="row.commentId">
                    <td>
                        <a :href="`/?controller=admin&action=editperson&personid=${ row.personId }`" 
                            target="_blank">
                            {{ row.firstName }} {{ row.familyName }}
                        </a>
                    </td>
                    <td>{{ row.comment }}</td>
                    <td>{{ $_formatDateTime($_dateFormat.DATETIME_DMYHI, row.dateEntered) }}</td>
                    <td>
                        <template v-if="row.dateTimeStart === null">
                            <span>{{ $_locale('always') }}</span>
                        </template>
                        <template v-if="row.dateTimeStart !== null">
                            <span>{{ $_formatDateTime($_dateFormat.DATETIME_HI, row.dateTimeStart) }}</span>
                            -
                            <span>{{ $_formatDateTime($_dateFormat.DATETIME_HI, row.dateTimeEnd) }}</span>
                        </template>
                    </td>
                    <td>
                        <span v-if="row.public">{{ $_locale('yes') }}</span>
                        <span v-if="!row.public">{{ $_locale('no') }}</span>
                    </td>
                    <td>
                        <div style="display: flex;flex-direction: row;gap:5px;">
                            <button class="btn btn-xs btn-default" 
                                @click="setEditComment(row)"
                                :title="$_locale('edit')">
                                <i class="glyphicon glyphicon-pencil"></i>
                            </button>
                            <button class="btn btn-xs btn-danger" 
                                @click="deleteComment(row)"
                                :title="$_locale('delete')">
                                <i class="glyphicon glyphicon-trash"></i>
                            </button>
                        </div>                        
                    </td>
                    </tr>
                </template>
            </wn-table-pages>
            <div class="clearfix"></div>
        </div>
        <div v-show="view === 'comment'">
            <EditResourceComment 
                :resource="selectedResource"
                ref="editResourceComment" 
                @success="changeView('list')" />
        </div>
    </div>
    <div class="modal-footer">
        <div v-show="view === 'list'">
            <button class="btn btn-default pull-left" 
                @click="$store.commit('common/setModal', null)">
                {{ $_locale('close') }}
            </button>
            <button class="btn btn-default pull-right"
                @click="setEditComment(null)">
                {{ $_locale('add new') }}
            </button>
        </div>
        <div v-show="view === 'comment'">
            <button class="btn btn-default pull-left" 
                @click="changeView('list')">
                {{ $_locale('cancel') }}
            </button>
            <button class="btn btn-danger pull-right"
                v-if="!!editComment.commentId"
                @click="$refs.editResourceComment.deleteComment()">
                {{ $_locale('delete') }}
            </button>
            <button class="btn btn-success pull-right"
                @click="$refs.editResourceComment.saveComment()">
                {{ $_locale('save') }}
            </button>
        </div>
    </div>
</div>
</Teleport>
</template>

<script>
import { mapGetters } from 'vuex'
import EditResourceComment from './EditResourceComment.vue'

export default {
    components: {
        EditResourceComment
    },
    props: {
        resource: {
            type: Object,
            required: true,
        },
        resources: {
            type: Array,
            required: false,
            default: () => []
        },
    }, 
    data: () => ({
        selectedResourceId: null,
        view: 'list',
        editComment: {
            comment: '',
            commentId: null,
            validFrom: null,
            validTo: null,
            baseDate: null,
            publicComment: false,
        }
    }),
    computed: {
        ...mapGetters({
            adminMode: 'common/adminMode',
            product: 'ecom/product',
            modalIsOpen: 'common/modalIsOpen',
            modalName: 'common/modalName',
            resourceComments: 'reservations/resourceComments',
            date: 'reservations/date',
        }),
        resourceCommentRows() {
            const date = this.date.format('YYYY-MM-DD');

            return this.resourceComments
                .filter(row => moment(row.dateTimeStart).format('YYYY-MM-DD') === date)
                .filter(row => row.resourceId === this.selectedResourceId)
        },
        selectedResource() {
            if (this.resources.length === 0) return this.resource;

            const selectedResourceId = this.selectedResourceId
            const [ selectedResource ] = this.resources.filter(row => row.resourceId == selectedResourceId)

            return selectedResource;
        },
    },
    watch: {
        modalName(val) {
            if (val !== 'resourcecommentmodal') return;

            this.selectedResourceId = this.resource.resourceId;
        },
    },
    methods: {
        changeView(name) {
            this.view = name;
        },
        setEditComment(comment) {
            this.changeView('comment');
            this.$nextTick(() => {
                this.$refs.editResourceComment.init(comment);
            })
        },
        deleteComment(comment) {
            this.$store.dispatch('reservations/deleteResourceComment', comment)
                .then(response => {
                    const { data } = response;

                    if (data.success) {
                        this.changeView('list')
                    }
                })
        },
    },
    mounted() {
    }
}
</script>